if (!customElements.get('luggex-purchase-assurance')) {
  customElements.define('luggex-purchase-assurance', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-assurance-trigger]');
        if (!trigger || !this.contains(trigger)) return;
        const panel = Array.from(this.querySelectorAll('.lx-assurance__panel')).find(item => item.id === trigger.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
